import { render } from "./photosPage.vue?vue&type=template&id=52ce993b"
import script from "./photosPage.vue?vue&type=script&lang=js"
export * from "./photosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__